module.exports = __webpack_public_path__ + "static/odin-bcf325613a1b9462a20bc0e0080f8a96.webm";